import { css } from "@obby/components";

export const styles = {
  terms: css({
    marginTop: "100px",
    "@md": {
      marginTop: "120px"
    }
  }),
  sideNav: css({
    listStyle: "none",
    paddingLeft: 0
  }),
  sideNavItem: css({
    margin: "10px 0"
  }),
  sideNavItemSelected: css({
    fontWeight: "bold"
  }),
  sideNavItemLink: css({
    color: "#212529",
    ":visited": {
      color: "inherit"
    },
    ":hover": {
      color: "inherit"
    }
  })
};
